document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const revealEnabled = document.body?.dataset.revealEnabled === 'true';

if (revealEnabled && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
    }
  );

  document.querySelectorAll('[data-reveal]').forEach((element) => {
    observer.observe(element);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-reveal]').forEach((element) => {
      observer.observe(element);
    });
  });
}
